export const UNINITIALIZED = 'uninitialized';
export const LOADING = 'loading';
export const SUCCESS = 'success';
export const ERROR = 'error';